import script from "./CompanyInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyInfo.vue?vue&type=script&setup=true&lang=js"

import "./CompanyInfo.vue?vue&type=style&index=0&id=7ed7fa1f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ed7fa1f"]])

export default __exports__